import React from 'react';
import ProductSliderItem, {ProductSliderItemEditable} from 'components/RelatedProductsSlider/components/ProductSliderItem';
import {map} from 'lodash'

import { 
  ItemGrid
} from './ProductItemGrid.styles.js';


const ProductItemGrid = ({items}) => {
  
  return (
    <ItemGrid>
      <div className="item-grid">
        {
          map(items, (item, i) => {
            return (
              <ProductSliderItem style={{paddingRight: '20px'}} fromInternal={true} key={item.id} {...item}  />
            )
          })
        }
      </div>
    </ItemGrid>
  )
}


export const ProductItemGridEditable = ({items, onClick=()=>{}}) => {
  
  return (
    <ItemGrid>
      <div className="item-grid">
        {
          map(items, (item, i) => {
            return (
              <ProductSliderItemEditable onClick={onClick.bind(this, item)} style={{paddingRight: '20px'}} fromInternal={true} key={item.id} {...item}  />
            )
          })
        }
      </div>
    </ItemGrid>
  )
}


export default ProductItemGrid;
